export default "__VITE_ASSET__f1c1d121__"